<template>
  <el-container class="full-height-container">
    <el-main class="main-content">
      <form-companies
        :service="model.service"
        :company="formCompany.model"
        :plan="model.plan"
        :add-ons-mandatory="form.model.addOns"
        :coupon="model.coupon"
        :price="companyServicePrice"
        :recurrence="companyServiceFrequencyBilling"
        :is-service-loading="loading.service"
        @next="onNext"
        @update:company="formCompany.model = $event"
      />
    </el-main>

    <el-footer class="footer-stats">
      <el-row type="flex" justify="center" align="middle">
        <el-col :xs="22" :sm="20" :md="18" :lg="16" :xl="14">
          <div class="stats-container">
            <div class="stat-item">
              <el-link href="https://aliaddo.com/blog" target="_blank" rel="noopener noreferrer">
                <i class="fad fa-blog"></i>
                {{ $tc('blog') }}
              </el-link>
            </div>

            <div class="stat-divider"></div>

            <div class="stat-item">
                 <el-link
                href="https://www.facebook.com/aliaddo.co"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fab fa-facebook"></i>
              Facebook
              </el-link>
            </div>

            <div class="stat-divider"></div>

            <div class="stat-item">
                  <el-link href="https://twitter.com/aliaddo_co" target="_blank" rel="noopener noreferrer">
                <i class="fab fa-twitter"></i>
                X
              </el-link>
            </div>
            <div class="stat-divider"></div>

            <div class="stat-item">
                         <el-link
                href="https://www.instagram.com/aliaddo.co"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fab fa-instagram"></i>
                Instagram
              </el-link>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { meanBy, sum, sumBy } from 'lodash'

/* End of vendors
-------------------------------------------------- */
/* app
-------------------------------------------------- */
import { mapFilters } from '@/filters/map-filters'
import { buildQueryString } from '@/helpers'
import form from '@/views/common/form'
import { addOnTotalize } from '@/views/company/calculate-total'
import modelCompany from '@/views/company/model'
import { axiosNext } from '../../services'
import model from './model'
import rules from './rules'

/* End of app
-------------------------------------------------- */

export default {
  name: 'RegisterCompanies',
  components: {
    FormCompanies: () => import('@/views/signup/form-companies'),
  },
  props: {
    detailType: {
      type: String,
      required: false,
      default: '',
    },
    frequencyBilling: {
      type: String,
      required: false,
      default: '',
    },
    plan: {
      type: Object,
      required: false,
      default() {
        return {
          features: [],
          id: '',
        }
      },
    },
  },
  data() {
    return {
      form: form({ model, rules }),
      formCompany: form({ model: modelCompany }),
      loading: {
        addOn: false,
        plan: false,
        service: false,
      },
      list: {
        addOns: [],
      },
      modal: {
        register: false,
      },
      model: {
        service: {},
        plan: {},
        coupon: {},
      },
    }
  },
  computed: {
    hidePersonalizePlan: _this => ['site', 'crm', 'package'].includes(_this.$route.query.source),
    hidePrice: _this => [_this.service === 'nomina-full'],
    featuresQuery: _this => {
      // Si existe el query parameter 'features', parseamos y actualizamos las cantidades
      if (_this.$route.query.features) {
        const featuresQuery = _this.$route.query.features

        // Parseamos el string "employees:1,crm:2" a un objeto
        const featuresMap = featuresQuery.split(',').reduce((acc, item) => {
          const [featureField, quantity] = item.trim().split(':')
          if (featureField && quantity) {
            acc[featureField.trim()] = parseInt(quantity, 10)
          }

          return acc
        }, {})

        return featuresMap
      }

      return []
    },
    sourceIsCrm: _this => _this.$route.query.source === 'crm',
    isIsvService: _this => _this.service === 'isv',

    crmParams: _this => {
      if (_this.$route.query.product) {
        return _this.$route.query.product.split('-')
      }

      return []
    },

    product: _this => {
      if (_this.$route.query.product && _this.$route.query.plan) {
        return _this.$route.query.product.toLowerCase()
      }
      if (_this.crmParams.length > 0) {
        return _this.crmParams[0].trim().toLowerCase()
      }

      return ''
    },

    service: _this => {
      if (_this.$route.query.product && _this.$route.query.plan) {
        return _this.$route.query.product.toLowerCase()
      }
      if (_this.crmParams.length > 0) {
        return _this.crmParams[0].trim().toLowerCase()
      }

      return ''
    },

    planName: _this => {
      if (_this.$route.query.plan) {
        return _this.$route.query.plan
      }
      if (_this.crmParams.length > 1) {
        return _this.crmParams[1].trim()
      }

      return ''
    },

    periodicidad: _this => {
      if (_this.$route.query.periodicidad) {
        return _this.$route.query.periodicidad
      }
      if (_this.crmParams.length > 2) {
        return _this.crmParams[2].trim()
      }

      return ''
    },

    price: _this => {
      if (_this.$route.query.price) {
        return _this.$route.query.price
      }
      if (_this.crmParams.length > 3) {
        return _this.crmParams[3].trim()
      }

      return ''
    },

    couponCode: _this => {
      if (_this.$route.query.coupon) {
        return _this.$route.query.coupon
      }

      return ''
    },

    modeBill: _this => {
      if (_this.serviceId === 7 || _this.serviceId === 11) {
        const mode = _this.planName.replace(/\s/g, '')
        if (
          mode.toLowerCase() === 'demanda' ||
          mode.toLowerCase() === 'paqueteindividual'
        ) {
          return mode
        }
        if (
          _this.form.model &&
          _this.form.model.planMode.toLowerCase() === 'paquete'
        ) {
          return 'paqueteGlobal'
        }

        return ''
      }
    },

    serviceId: _this => {
      if (_this.service === 'aliaddo') {
        return 2
      }
      if (_this.service === 'isv') {
        return 7
      }
      if (_this.service === 'aliaddopos') {
        return 8
      }
      if (_this.service === 'crm') {
        return 9
      }
      if (_this.service === 'nomina-full') {
        return 10
      }
      if (_this.service === 'nomina-lite') {
        return 11
      }
      if (_this.service === 'nomina-isv') {
        return 12
      }
      if (_this.service === 'aliaddo-desk') {
        return 13
      }
    },

    companyServiceFrequencyBilling: _this => {
      if (_this.frequencyBilling) {
        return _this.frequencyBilling
      }
      let frecuency = ''
      switch (_this.periodicidad) {
        case 'Anual':
          frecuency = 'Yearly'
          break
        case 'Mensual':
          frecuency = 'Monthly'
          break
        case 'Trimestral':
          frecuency = 'Quarterly'
          break
        case 'Semestral':
          frecuency = 'Semiannual'
          break
        default:
          frecuency = 'Yearly' // Default
      }

      return frecuency
    },

    companyServiceFrequencyBillingQuantity: _this => {
      let frecuencyQuantity = 0
      switch (_this.companyServiceFrequencyBilling) {
        case 'Yearly':
          frecuencyQuantity = 12
          break
        case 'Monthly':
          frecuencyQuantity = 1
          break
        case 'Quarterly':
          frecuencyQuantity = 3
          break
        case 'Semiannual':
          frecuencyQuantity = 6
          break
        default:
          frecuencyQuantity = 12
      }

      return frecuencyQuantity
    },

    companyServicePrice: _this => {
      let price = 0
      switch (_this.companyServiceFrequencyBilling) {
        case 'Yearly':
          price =
            _this.price === 'new'
              ? _this.form.model.planPriceYearlyNew
              : _this.form.model.planPriceYearly
          break
        case 'Monthly':
          price =
            _this.price === 'new'
              ? _this.form.model.planPriceMonthlyNew
              : _this.form.model.planPriceMonthly
          break
        case 'Quarterly':
          price =
            _this.price === 'new'
              ? _this.form.model.planPriceQuarterlyNew
              : _this.form.model.planPriceQuarterly
          break
        case 'Semiannual':
          price =
            _this.price === 'new'
              ? _this.form.model.planPriceSemiannualNew
              : _this.form.model.planPriceSemiannual
          break
        default:
          price = 0 // Precio por defecto
      }

      return price || 0
    },

    companyServicePlanTaxBase: _this => _this.companyServicePrice -
      (
        _this.companyServicePrice *
        ((_this.form.model.planTaxPercentIncluded || 0) / 100)
      ).toFixed(2),

    companyServicePlanIvaBase: _this => _this.companyServicePrice -
      (
        _this.companyServicePrice *
        ((_this.form.model.planTaxPercentIncluded || 0) / 100)
      ).toFixed(2),

    companyServicePlanIvaPercent: _this => _this.form.model.planTaxPercentIncrease ||
      _this.form.model.planTaxPercentIncluded ||
      0,

    companyServicePlanIvaValue: _this => +(
      _this.companyServicePrice *
        ((_this.form.model.planTaxPercentIncrease ||
          _this.form.model.planTaxPercentIncluded ||
          0) /
          100)
    ).toFixed(2),

    // Precio original de las features (sin descuento) - usa precio total por capas si está disponible
    companyPlanFeaturePriceOriginal: _this => sum(
      _this.form.model.features
        .filter(item => item.featureAddonQuantity)
        .map(
          item => +(
            (item.featureTotalPrice ||
              (item.featureUnitPriceOriginal || item.featureUnitPriceCustom) * +item.featureAddonQuantity) *
                +_this.companyServiceFrequencyBillingQuantity
          ).toFixed(2),
        ),
    ),

    // Precio con descuento aplicado (precio final) - usa precio total por capas si está disponible
    companyPlanFeaturePrice: _this => sum(
      _this.form.model.features
        .filter(item => item.featureAddonQuantity)
        .map(
          item => +(
            (item.featureTotalPriceWithDiscount ||
              item.featureUnitPriceCustom * +item.featureAddonQuantity) *
                +_this.companyServiceFrequencyBillingQuantity
          ).toFixed(2),
        ),
    ),

    // Total de descuentos aplicados a las features
    companyPlanFeatureDiscount: _this => _this.companyPlanFeaturePriceOriginal - _this.companyPlanFeaturePrice,

    companyPlanFeatureTaxBase: _this => _this.companyPlanFeaturePrice -
      (
        _this.companyPlanFeaturePrice *
        ((_this.form.model.planTaxPercentIncluded || 0) / 100)
      ).toFixed(2),

    companyPlanFeatureIvaBase: _this => _this.companyPlanFeaturePrice -
      (
        _this.companyPlanFeaturePrice *
        ((_this.form.model.planTaxPercentIncluded || 0) / 100)
      ).toFixed(2),

    companyPlanFeatureIvaPercent: _this => _this.form.model.planTaxPercentIncrease ||
      _this.form.model.planTaxPercentIncluded ||
      0,

    companyPlanFeatureIvaValue: _this => +(
      _this.companyPlanFeaturePrice *
        ((_this.form.model.planTaxPercentIncrease ||
          _this.form.model.planTaxPercentIncluded ||
          0) /
          100)
    ).toFixed(2),

    companyPlanFeatureAmount: _this => +(
      _this.companyPlanFeaturePrice *
        ((_this.form.model.planTaxPercentIncrease ||
          _this.form.model.planTaxPercentIncluded ||
          0) /
          100)
    ).toFixed(2),

    companyServiceAddOnPrice: _this => sumBy(_this.formCompany.model.addOns, 'addOnPrice'),
    companyServiceAddOnTaxBase: _this => sumBy(_this.formCompany.model.addOns, 'addOnTaxBase'),
    companyServiceAddOnIvaBase: _this => sumBy(_this.formCompany.model.addOns, 'addOnTaxBase'),
    companyServiceAddOnIvaPercent: _this => meanBy(_this.formCompany.model.addOns, item => item.addOnIvaPercent),
    companyServiceAddOnIvaValue: _this => sumBy(_this.formCompany.model.addOns, 'addOnIvaValue'),

    companyServiceAmount: _this => {
      if (_this.modeBill && _this.modeBill.toLowerCase() === 'demanda') {
        return _this.companyServiceAddOnPrice + _this.companyPlanFeaturePrice
      }

      return (
        _this.companyServicePrice +
        _this.companyServiceAddOnPrice +
        _this.companyPlanFeaturePrice
      )
    },

    companyServiceTaxBase: _this => _this.companyServicePlanTaxBase +
      _this.companyPlanFeatureTaxBase +
      _this.companyServiceAddOnTaxBase,

    companyServiceIvaBase: _this => {
      let ivaBase = 0
      if (_this.companyServicePlanIvaPercent > 0) {
        ivaBase += _this.companyServicePlanIvaPercent
      }

      if (_this.companyServicePlanIvaPercent > 0) {
        ivaBase += _this.companyServicePlanIvaPercent
      }

      if (_this.companyServiceAddOnIvaPercent > 0) {
        ivaBase += _this.companyServiceAddOnIvaPercent
      }

      return ivaBase
    },

    companyServiceIvaPercent: _this => {
      if (
        _this.companyServicePlanIvaPercent > 0 &&
        _this.companyServiceAddOnIvaPercent > 0
      ) {
        return +(
          (_this.companyServicePlanIvaPercent +
            _this.companyServiceAddOnIvaPercent) /
          2
        ).toFixed(2)
      }

      return (
        (_this.companyServicePlanIvaPercent || 0) +
        (_this.companyServiceAddOnIvaPercent || 0)
      )
    },

    companyServiceIvaValue: _this => +(_this.companyServicePlanIvaValue || 0) +
      (_this.companyServiceAddOnIvaValue || 0),

    companyServiceAmountTotal: _this => {
      let amountTotal = _this.companyServiceAmount

      if (_this.form.model.planTaxPercentIncrease > 0) {
        amountTotal += _this.companyServicePlanIvaValue
      }

      amountTotal +=
        sum(
          _this.formCompany.model.addOns.map(item => (item.addOnTaxPercentIncrease ? item.addOnIvaValue : 0),
          ),
        ) || 0

      return amountTotal
    },
  },

  mounted() {
    this.getService()
    this.getPlan()
      .then(this.getCoupon)
      .then(this.getAddOnsMandatory)
      .finally(() => (this.loading.service = false))
  },

  methods: {
    ...mapFilters(['toCamelCase']),
    ...{
      addOnTotalize,
    },

    onSelectAddOn(value) {
      const _this = this
      if (value.length > 0) {
        _this.formCompany.model.addOns = value.map(item => addOnTotalize(item))

        return
      }
      _this.formCompany.model.addOns = value
    },

    onNext() {
      const _this = this
      _this.formCompany.model = {
        planId: _this.form.model.id,
        serviceId: _this.serviceId,
        features: _this.form.model.features,
        addOns: _this.formCompany.model.addOns,
        companyServicePrice: _this.companyServicePrice,
        companyServiceSource: _this.$route.query.source,
        companyServiceModeBill: _this.modeBill,
        companyServiceFrequencyBilling: _this.companyServiceFrequencyBilling,
      }

      _this.$emit('update:company', _this.formCompany.model)

      if (['crm', 'site'].includes(_this.$route.query.source)) {
        _this.modal.register = true
      } else {
        _this.$emit('next', {
          company: _this.formCompany.model,
          voucher: {
            voucherRecurrence: _this.companyServiceFrequencyBilling,
            voucherAmount: _this.companyServiceAmount,
            voucherTaxBase: _this.companyServiceTaxBase,
            voucherIvaBase: _this.companyServiceIvaBase,
            voucherIvaPercent: _this.companyServiceIvaPercent,
            voucherIvaValue: _this.companyServiceIvaValue,
            voucherAmountTotal: _this.companyServiceAmountTotal,
          },
        })
      }
    },

    getFeatures() {
      return this.form.model.features
        .filter(
          item => item.featureType !== 'access' &&
            +item.featureUnitPriceCustom > 0 &&
            item.featureIsVisible === 'true',
        )
        .sort((a, b) => a.featureValue - b.featureValue)
    },

    getAddOns() {
      const _this = this

      _this.formCompany.model.addOns = []
      _this.loading.addOn = true

      return _this.$http
        .get(
          `add-ons/${_this.serviceId}/${_this.form.model.id}/findByServiceByPlan?onlyEnabled=true`,
        )
        .then(result => {
          _this.list.addOns = result.body
          if (_this.list.addOns.length > 0 && this.detailType === 'Apertura') {
            _this.onSelectAddOn(
              _this.list.addOns.filter(item => item.addOnIsMandatory),
            )
          }

          return result.body
        })
        .finally(() => (_this.loading.addOn = false))
    },

    getPlan() {
      const _this = this
      if (_this.plan && _this.plan.id > 0) {
        _this.form.model = { ..._this.form.model, ..._this.plan }

        return _this.getAddOns().then(() => {
          if (_this.hidePersonalizePlan) {
            _this.onNext()
          }
        })
      }

      _this.loading.plan = true
      const queryString = buildQueryString({
        serviceId: _this.serviceId,
        planName: _this.planName,
        planEnabled: true,
      })

      return _this.$http
        .get(`plans/findByName?${queryString}`)
        .then(response => {
          if (!response.data || response.data.id < 1) {
            this.$message({
              showClose: true,
              message: _this.$tc('messageNoFoundPlan') || 'Plan no encontrado',
              type: 'error',
            })
          } else if (response.data && response.data.id === 383) {
            this.$message({
              showClose: true,
              message: _this.$tc('messageNoFoundPlan') || 'Plan no encontrado',
              type: 'error',
            })
          } else {
            const plan = response.data

            plan.features = plan.features.map(feature => {
              const featureField = feature.featureField || feature.featureName

              const featureAddonQuantity = _this.featuresQuery[featureField] || 0

              return {
                ...feature,
                featureAddonQuantity,
                featureUnitPriceCustom: 0, // Se actualizará cuando se carguen los addOns
              }
            })
            _this.form.model = { ..._this.form.model, ...plan }
            _this.model.plan = plan
          }

          /* Validar si la periodicidad esta mal y mostrar alerta */
          if (
            !_this.form.model.planFree &&
            _this.companyServiceAmountTotal <= 0 &&
            !_this.isIsvService
          ) {
            this.$message({
              showClose: true,
              message: _this.$tc('messagePlanPriceError') || 'Error en el precio del plan',
              type: 'error',
            })
          }

          return response.data
        })
        .catch(error => {
          console.error('Error al obtener plan:', error)
          this.$message.error('Error al cargar información del plan')
        })
        .finally(() => (_this.loading.plan = false))
    },

    getAddOnsMandatory() {
      const _this = this
      _this.loading.plan = true

      return axiosNext
        .get(`plans/${_this.model.plan.id}/addons-mandatory`)
        .then(response => {
          if (response && response.data && response.data.length > 0) {
            _this.form.model.addOns = response.data.map(item => ({
              addOnId: item.id,
              productId: item.serviceId,
              featureId: item.featureId,
              name: item.addOnName,
              featureName: item.featureName,
              featureField: item.featureField,
              price: item.addOnPrice,

              // Esquema de precio: 'tiered' (por capas), 'volume' (por rangos) o 'unit' (precio fijo)
              priceUnit: item.priceUnit || 0,
              pricingSchema: item.pricingSchema || 'tiered',
              priceBrackets: item.priceBrackets || [],
              quantity: 0,
              billedValue: 0,
              access: false,
              featureType: item.featureType,
            }))

            // Actualizar featureUnitPriceCustom para cada feature del plan
            _this.updateFeatureUnitPrices()
          } else {
            _this.form.model.addOns = []
          }
        })
        .catch(error => {
          console.error('Error al obtener add-ons:', error)
          _this.form.model.addOns = []
        })
        .finally(() => (_this.loading.plan = false))
    },

    /**
     * Calcula el precio unitario o total según el esquema de precios.
     *
     * Modelo Capa (tiered): Cada rango tiene su precio, el total se calcula sumando cada tramo.
     * Ejemplo: 5 unidades con tramos [1-3: $6, 4-6: $5]
     *   → 3 × $6 = $18 + 2 × $5 = $10 → Total: $28
     *
     * @param {Array} priceBrackets - Tramos de precios [{startingQty, endingQty, price}]
     * @param {number} quantity - Cantidad total de unidades
     * @param {number} basePrice - Precio base por defecto
     * @param {string} pricingSchema - 'tiered' (por capas), 'volume' (por volumen) o 'unit' (fijo)
     * @returns {number} - Para 'tiered': precio total | Para otros: precio unitario
     */
    findPriceByBracket(priceBrackets, quantity, basePrice, pricingSchema = 'tiered') {
      // Soporte para esquema de precio por unidad (precio fijo por unidad)
      if (pricingSchema === 'unit') {
        return basePrice || 0
      }

      if (!priceBrackets || priceBrackets.length === 0) {
        return basePrice
      }

      const sortedBrackets = [...priceBrackets].sort((a, b) => a.startingQty - b.startingQty)

      // Modelo Capa (Tiered): suma el costo de cada tramo
      if (pricingSchema === 'tiered') {
        let totalPrice = 0
        let remainingQty = quantity

        for (const bracket of sortedBrackets) {
          if (remainingQty <= 0) break

          const bracketStart = bracket.startingQty
          const bracketEnd = bracket.endingQty || Infinity
          const bracketPrice = bracket.price || basePrice

          // Calcular cuántas unidades caen en este tramo
          const bracketSize = bracketEnd - bracketStart + 1
          const unitsInBracket = Math.min(remainingQty, bracketSize)

          totalPrice += unitsInBracket * bracketPrice
          remainingQty -= unitsInBracket
        }

        // Si quedan unidades después de todos los tramos, usar el precio base
        if (remainingQty > 0) {
          totalPrice += remainingQty * basePrice
        }

        return totalPrice
      }

      // Modelo Volumen: encuentra el precio único según el rango donde cae la cantidad
      for (const bracket of sortedBrackets) {
        if (quantity >= bracket.startingQty) {
          const maxQty = bracket.endingQty || Infinity

          if (quantity <= maxQty) {
            return bracket.price || basePrice
          }
        }
      }

      return basePrice
    },

    calculateFeatureUnitPrice(unitPrice) {
      let adjustedPrice = unitPrice

      // Aplicar descuento del cupón si existe
      if (this.model.coupon && this.model.coupon.discount) {
        if (this.model.coupon.discountType === 'Percent') {
          const discountPercentage = this.model.coupon.discountPercentage || this.model.coupon.discount || 0
          adjustedPrice *= (1 - discountPercentage / 100)
        } else if (this.model.coupon.discountType === 'fixed') {
          adjustedPrice = Math.max(0, adjustedPrice - (this.model.coupon.discount || 0))
        }
      }

      return adjustedPrice
    },

    updateFeatureUnitPrices() {
      const _this = this

      if (!_this.form.model.features || !_this.form.model.addOns) return

      const updatedFeatures = _this.form.model.features.map(feature => {
        if (!feature.featureAddonQuantity || +feature.featureAddonQuantity === 0) {
          return feature
        }

        // Buscar addon por featureId o por featureField
        const addon = _this.form.model.addOns.find(a => a.featureId === feature.id || a.featureField === feature.featureField)

        const quantity = +feature.featureAddonQuantity || 0

        const basePrice = addon ? addon.priceUnit || 0 : 0

        const priceBrackets = addon ? addon.priceBrackets : null
        const pricingSchema = addon ? addon.pricingSchema || 'tiered' : 'tiered'

        // Para 'tiered': retorna precio total | Para otros: retorna precio unitario
        const priceResult = _this.findPriceByBracket(priceBrackets, quantity, basePrice, pricingSchema)

        // En modelo tiered, el resultado ya es el precio total; en otros es precio unitario
        const isTiered = pricingSchema === 'tiered'
        const totalPriceOriginal = isTiered ? priceResult : priceResult * quantity
        const unitPriceOriginal = isTiered && quantity > 0 ? priceResult / quantity : priceResult

        const totalPriceWithDiscount = _this.calculateFeatureUnitPrice(totalPriceOriginal)
        const unitPriceWithDiscount = isTiered && quantity > 0 ? totalPriceWithDiscount / quantity : _this.calculateFeatureUnitPrice(priceResult)

        return {
          ...feature,
          featurePricingSchema: pricingSchema,
          featureUnitPriceCustom: unitPriceOriginal, // Precio unitario promedio (para mostrar)
          featureUnitPriceWithDiscount: unitPriceWithDiscount, // Precio unitario con descuento
          featureUnitDiscount: unitPriceOriginal - unitPriceWithDiscount, // Descuento por unidad
          featureTotalPrice: totalPriceOriginal, // Precio total calculado por capas
          featureTotalPriceWithDiscount: totalPriceWithDiscount, // Precio total con descuento
        }
      })

      // Actualizar ambos form.model.features y model.plan.features para reactividad
      _this.form.model.features = updatedFeatures
      if (_this.model.plan) {
        _this.$set(_this.model, 'plan', {
          ..._this.model.plan,
          features: updatedFeatures,
        })
      }
    },

    getService() {
      const _this = this
      _this.loading.service = true

      _this.$http
        .get(`services/${_this.serviceId}`)
        .then(response => (_this.model.service = response.data))
        .catch(error => {
          console.error('Error al obtener servicio:', error)
          _this.model.service = {}
        })
        .finally(() => (_this.loading.service = false))
    },

    getCoupon() {
      // Obtener cupón si existe en la URL
      if (this.couponCode && this.couponCode.trim() !== '') {
        const _this = this
        _this.loading.service = true

        return axiosNext
          .get('coupons/redeem', {
            params: {
              productId: _this.serviceId,
              planId: _this.form.model.id,
              code: _this.couponCode,
              recurrence: _this.companyServiceFrequencyBilling,
            },
          })
          .then(response => {
            _this.model.coupon = response.data

            return response.data
          })
      }

      return Promise.resolve({})
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/transactions/personalize.scss';
@import '~element-ui/lib/theme-chalk/display.css';

/* Layout principal CON footer pegado abajo pero sin scroll forzado */
.full-height-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;

  // Asegurar que el contenido tome todo el height disponible
  > * {
    flex: 1;
    height: 100%;
  }
}

/* Footer en la parte inferior */
.footer-stats {
  background-color: #f5f5f5 !important;
  color: #666666 !important;
  font-size: 12px;
  height: auto !important;
  padding: 12px 20px !important;
  flex-shrink: 0;
  border-top: 1px solid #e0e0e0;

  .stats-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 40px;

    @media (max-width: 768px) {
      gap: 20px;
      justify-content: space-around;
    }
  }

  .stat-item {
    display: flex;
    align-items: center;
    gap: 6px;

    .el-link {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #666666 !important;
      text-decoration: none;
      font-size: 12px;
      font-weight: 500;
      transition: color 0.2s ease;

      &:hover {
        color: #333333 !important;
        text-decoration: none;
      }

      i {
        font-size: 14px;
        transition: color 0.2s ease;
      }
    }
  }

  .stat-divider {
    width: 1px;
    height: 20px;
    background-color: #e0e0e0;

    @media (max-width: 768px) {
      display: none;
    }
  }
}

/* Estilos adicionales para el formulario */
.el-alert.el-alert--success {
  background-color: var(--classyPalette4);
  border-color: var(--classyPalette4);
  color: var(--spotPalette4);
}

.ellipse {
  height: 45px;
  line-height: 1.4em;
  display: flex;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.image-bg {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-image: url('../../assets/img/svg/login-erp.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
}

/* Overrides para Element UI - Footer pegado abajo */
.el-container {
  min-height: 100vh !important;
}

.el-main {
  overflow-y: visible;
  flex: 1;
}

.el-footer {
  height: auto !important;
  padding: 12px 20px !important;
}
</style>
